<template>
  <div class="canvas-container" v-on:click="onClickOutsideCanvas">
    <div v-for="item in canvases" :key="item.side"
         :id="item.canvasId" :class="[item.canvasId, {activeCanvas: jacketSide === item.side}]">
    </div>
    <div class="total-price-wrap">
      <div class="total-price">
        <b-spinner v-if="!totalPrice" variant="primary"/>
        <h4 v-if="totalPrice">Total Price: ${{totalPrice}}</h4>
      </div>
    </div>

    <div v-if="activePatchElement" class="patch-price-wrap">
      <h4 class="patch-price">
        {{ patchPriceLabel }}: ${{totalPatchPrice}}&nbsp;
        @ {{selectedPatch.patchSize.size}}" {{ patchSide }}
      </h4>
      <h6 class="patch-sizes-title">Available Sizes:</h6>
      <h6 class="patch-sizes">{{availableSizes}} </h6>
    </div>

    <div class="jacket-container">
      <div class="sub-image-wrapper" ref="imageContainer">
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.FRONT"
          class="sub-image"
          :src="require('@/assets/images/jacket-front-sub-setIn-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.6}%`,
                 top: `${50.5}%`,
                 width: '450px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.FRONT"
          class="sub-image"
          :src="require('@/assets/images/jacket-front-sub-setIn-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.5}%`,
                 top: `${49.5}%`,
                 width: '451px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.FRONT"
          class="sub-image"
          :src="require('@/assets/images/jacket-front-sub-setIn-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.5}%`,
                 top: `${51.3}%`,
                 width: '451px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.FRONT"
          class="sub-image"
          :src="require('@/assets/images/jacket-front-sub-raglan-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.4}%`,
                 top: `${50.5}%`,
                 width: '450px',
                 transform: `translate(${-49.9}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.FRONT"
          class="sub-image"
          :src="require('@/assets/images/jacket-front-sub-raglan-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.5}%`,
                 top: `${49.5}%`,
                 width: '451px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.FRONT"
          class="sub-image"
          :src="require('@/assets/images/jacket-front-sub-raglan-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.5}%`,
                 top: `${51.3}%`,
                 width: '451px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >

        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.BACK"
          class="sub-image"
          :src="require('@/assets/images/jacket-back-sub-setIn-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.6}%`,
                 top: `${50.5}%`,
                 width: '450px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.BACK"
          class="sub-image"
          :src="require('@/assets/images/jacket-back-sub-setIn-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.6}%`,
                 top: `${48.5}%`,
                 width: '462px',
                 transform: `translate(${-49.9}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.BACK"
          class="sub-image"
          :src="require('@/assets/images/jacket-back-sub-setIn-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.5}%`,
                 top: `${50.6}%`,
                 width: '451px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.BACK"
          class="sub-image"
          :src="require('@/assets/images/jacket-back-sub-raglan-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.6}%`,
                 top: `${50.9}%`,
                 width: '450px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.BACK"
          class="sub-image"
          :src="require('@/assets/images/jacket-back-sub-raglan-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.6}%`,
                 top: `${48.4}%`,
                 width: '450px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.BACK"
          class="sub-image"
          :src="require('@/assets/images/jacket-back-sub-raglan-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${50.4}%`,
                 top: `${50.7}%`,
                 width: '454px',
                 transform: `translate(${-49.8}%, ${-50}%)`,
          }"
        >

        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.LEFT"
          class="sub-image"
          :src="require('@/assets/images/jacket-left-sub-setIn-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50}%`,
                 top: `${50.5}%`,
                 width: '174px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.LEFT"
          class="sub-image"
          :src="require('@/assets/images/jacket-left-sub-setIn-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${51}%`,
                 top: `${48}%`,
                 width: '194px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.LEFT"
          class="sub-image"
          :src="require('@/assets/images/jacket-left-sub-setIn-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${51}%`,
                 top: `${49}%`,
                 width: '191px',
                 transform: `translate(${-50.5}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.LEFT"
          class="sub-image"
          :src="require('@/assets/images/jacket-left-sub-raglan-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50}%`,
                 top: `${51.5}%`,
                 width: '173px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.LEFT"
          class="sub-image"
          :src="require('@/assets/images/jacket-left-sub-raglan-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${51}%`,
                 top: `${48}%`,
                 width: '194px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.LEFT"
          class="sub-image"
          :src="require('@/assets/images/jacket-left-sub-raglan-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${51}%`,
                 top: `${49}%`,
                 width: '191px',
                 transform: `translate(${-50.5}%, ${-50}%)`,
          }"
        >

        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.RIGHT"
          class="sub-image"
          :src="require('@/assets/images/jacket-right-sub-setIn-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50}%`,
                 top: `${50.5}%`,
                 width: '174px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.RIGHT"
          class="sub-image"
          :src="require('@/assets/images/jacket-right-sub-setIn-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${49}%`,
                 top: `${48}%`,
                 width: '194px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.SET_IN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.RIGHT"
          class="sub-image"
          :src="require('@/assets/images/jacket-right-sub-setIn-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${49.5}%`,
                 top: `${49}%`,
                 width: '190px',
                 transform: `translate(${-51}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType.toLowerCase() === COLLARS.CLASSIC
          && jacketSide === JACKET_SIDES.RIGHT"
          class="sub-image"
          :src="require('@/assets/images/jacket-right-sub-raglan-classic.png')"
          :style="{
                 position: 'absolute',
                 left: `${50}%`,
                 top: `${51.5}%`,
                 width: '173px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.HOODIE
          && jacketSide === JACKET_SIDES.RIGHT"
          class="sub-image"
          :src="require('@/assets/images/jacket-right-sub-raglan-hood.png')"
          :style="{
                 position: 'absolute',
                 left: `${49}%`,
                 top: `${48}%`,
                 width: '194px',
                 transform: `translate(${-50}%, ${-50}%)`,
          }"
        >
        <img
          v-if="activeJacketType === JACKET_TYPE.RAGLAN
          && activeCollarType === COLLARS.ZIPPER_HOOD
          && jacketSide === JACKET_SIDES.RIGHT"
          class="sub-image"
          :src="require('@/assets/images/jacket-right-sub-raglan-zipper.png')"
          :style="{
                 position: 'absolute',
                 left: `${49.5}%`,
                 top: `${49}%`,
                 width: '190px',
                 transform: `translate(${-51}%, ${-50}%)`,
          }"
        >
      </div>
      <div id="jacket-wrap">
      </div>
    </div>

    <b-modal
      id="exist-patch-editor-modal"
      size="xl"
      hide-header
      hide-footer
      centered
      content-class="patch-editor-modal__content"
    >
      <PatchEditor
        modal-id="exist-patch-editor-modal"
        :is-pending="false"
        :patch-svg-text="patchSvgText"
        :patch-id="editingPatchId"
        :original-patch-id="editingPatchOriginalId"
      />
    </b-modal>

    <b-modal
      id="exist-text-patch-editor-modal"
      size="lg"
      hide-header
      hide-footer
      centered
      content-class="patch-editor-modal__content"
    >
      <TextPatchEditor
        modal-id="exist-text-patch-editor-modal"
        :patch-id="editingPatchId"
        :original-patch-id="editingPatchOriginalId"
        :is-text-embroidery="isTextEmbroidery"
      />
    </b-modal>
  </div>
</template>

<script>
import * as SVG from 'svg.js/dist/svg';

import 'svg.draggable.js/dist/svg.draggable';
import '@/common/svg/svg.select';
import 'svg.select.js/dist/svg.select.css';
import '@/common/svg/svg.resize';

import {
  JACKET_SIDES, JACKET_TYPE, COLLARS, getInchInPx
} from '@/common/constants';
import front from '@/assets/jacket/front.svg';
import back from '@/assets/jacket/back.svg';
import left from '@/assets/jacket/left.svg';
import right from '@/assets/jacket/right.svg';
import PatchEditor from '@/components/canvas/PatchEditor.vue';
import TextPatchEditor from '@/components/canvas/TextPatchEditor.vue';
import svgApi from '@/api/svgApi';

export default {
  name: 'Canvas',

  components: {
    PatchEditor,
    TextPatchEditor
  },

  data () {
    return {
      jacketId: '',
      jacket: null,
      jacketWidth: 0,
      jacketHeight: 0,
      canvases: [{

        id: '',
        canvas: null,
        canvasId: JACKET_SIDES.FRONT,
        patchesIsLoaded: false,
        side: JACKET_SIDES.FRONT
      },
      {
        id: '',
        canvas: null,
        canvasId: JACKET_SIDES.BACK,
        patchesIsLoaded: false,
        side: JACKET_SIDES.BACK
      },
      {
        id: '',
        canvas: null,
        canvasId: JACKET_SIDES.LEFT,
        patchesIsLoaded: false,
        side: JACKET_SIDES.LEFT
      },
      {
        id: '',
        canvas: null,
        canvasId: JACKET_SIDES.RIGHT,
        patchesIsLoaded: false,
        side: JACKET_SIDES.RIGHT
      }],
      canvasWidth: 815,
      canvasHeight: 492,
      patchElements: [],
      activePatchElement: null,
      patchSvgText: null,
      editingPatchId: null,
      editingPatchOriginalId: null,
      isTextEmbroidery: null,
      selectedPatch: {},
      JACKET_TYPE,
      COLLARS,
      JACKET_SIDES
    };
  },

  events: {
    Global_addPatchToProject ({ patchId }) {
      this.addPatch(patchId);
    },

    Global_updatePatchInProject ({ patchId }) {
      this.updatePatch(patchId);
    }
  },

  mounted () {
    this.initCanvas();
    this.initJacket();
    this.loadJacket();
  },

  beforeDestroy () {
    this.setPatchesOptions();
    this.canvases.forEach((item) => {
      // eslint-disable-next-line no-param-reassign
      item.patchesIsLoaded = false;
    });
    this.unselectPatchElements();
  },

  computed: {
    activeCollarType () {
      return this.$store.getters['design/getCollarType'];
    },

    activeTrimPattern () {
      return this.$store.getters['design/getActiveTrimPattern'];
    },

    availableSizes () {
      return this.getPatchAvailableSizes(this.selectedPatch)
        .map((size) => `${size}"`)
        .join(', ');
    },

    totalPatchPrice () {
      let sum = 0;
      if (this.selectedPatch.inserts) {
        this.selectedPatch.inserts.forEach((ins) => {
          sum += ins.sellingPrice;
        });
        return this.selectedPatch.patchSize.sellingPrice + sum;
      }
      return this.selectedPatch.patchSize.sellingPrice;
    },

    activeSideCanvas () {
      return this.canvases.filter((item) => item.canvasId === this.jacketSide)[0];
    },

    totalPrice () {
      return this.$store.getters['finalizeOrder/getTotalPrice'];
    },

    jacketSide () {
      return this.$store.getters['ui/getJacketSide'];
    },

    activeJacketType () {
      return this.$store.getters['design/getJacketType'];
    },

    patches () {
      return this.$store.getters['design/getProjectPatches'];
    },

    patchesBySide () {
      return (jacketSide) => this.$store.getters['design/getPatchesBySide'](jacketSide);
    },

    getPatchModel () {
      return (patchId) => this.$store.getters['elements/getPatchById'](patchId);
    },

    patchCategories () {
      return this.$store.getters['elements/getCategoriesOfPatches'];
    },

    getPatchSize () {
      return (patchId) => this.$store.getters['design/getPatchSize'](patchId);
    },

    elementsColor () {
      return [
        {
          id: '#body',
          color: this.$store.getters['design/getBodyColor']
        },
        {
          id: '#sleeves',
          color: this.$store.getters['design/getSleevesColor']
        },
        {
          id: '#snaps',
          color: this.$store.getters['design/getSnapsColor']
        },
        {
          id: '#pockets',
          color: this.$store.getters['design/getPocketsColor']
        },
        {
          id: '#baseTrims',
          color: this.$store.getters['design/getBaseTrimsColor']
        },
        {
          id: '#secondaryTrims',
          color: this.$store.getters['design/getSecondaryTrimsColor']
        },
        {
          id: '#finishTrims',
          color: this.$store.getters['design/getFinishTrimsColor']
        },
        {
          id: '#insideCollar',
          color: this.$store.getters['design/getInsideCollarColor']
        },
      ];
    },

    patchPriceLabel () {
      return this.selectedPatch.isTextEmbroidery ? 'Text Price' : 'Patch Price';
    },

    patchSide () {
      return this.selectedPatch.isTextPatch
      || (this.selectedPatch.patchSize.height > this.selectedPatch.patchSize.width) ? 'high' : 'wide';
    }
  },

  watch: {
    activeTrimPattern () {
      this.loadJacket();
    },
    activeCollarType () {
      this.loadJacket();
    },
    jacketSide () {
      this.loadJacket();
      this.unselectPatchElements();
    },
    activeJacketType () {
      this.loadJacket();
      this.unselectPatchElements();
    },
    elementsColor () {
      this.elementsColor.forEach((element) => {
        this.jacket.select(element.id).fill(element.color.hex);
      });
    },
  },

  methods: {
    setPatchesOptions () {
      const patchesOptions = this.patchElements.map((patchElement) => {
        const patchId = patchElement.id();
        const wrapper = patchElement.select(`#${patchId}--wrapper`).first();
        const x = patchElement.x();
        const y = patchElement.y();
        const cx = patchElement.cx();
        const cy = patchElement.cy();
        const transform = wrapper.node.getAttribute('transform');
        const transformData = wrapper.transform();

        const options = {
          x,
          y,
          cx,
          cy,
          transform,
          transformData,
        };

        return { id: patchId, options };
      });
      this.$store.dispatch('design/savePatchesOptions', patchesOptions);
    },

    initCanvas () {
      this.canvases.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.canvas = SVG(item.canvasId).size(this.canvasWidth, this.canvasHeight);
        // eslint-disable-next-line no-param-reassign
        item.id = item.canvas.node.id;
      });
    },

    initJacket () {
      this.jacket = SVG('jacket-wrap').size(this.canvasWidth, this.canvasHeight);
      this.jacketId = this.jacket.node.id;
    },

    loadJacket () {
      const svgToSide = {
        [JACKET_SIDES.FRONT]: front,
        [JACKET_SIDES.BACK]: back,
        [JACKET_SIDES.LEFT]: left,
        [JACKET_SIDES.RIGHT]: right,
      };
      const svgFile = svgToSide[this.jacketSide];
      const lastJacket = this.jacket.select('#jacket').last();
      if (lastJacket) {
        lastJacket.remove();
      }
      svgApi.loadLocalSvg(svgFile).then((svgText) => {
        this.jacket.svg(svgText);
        this.jacket.select('svg').last()
          .width(1100)
          .height(900)
          .id('jacket')
          .cx(this.jacket.cx())
          .cy(this.jacket.cy());
        this.elementsColor.forEach((element) => {
          this.jacket.select(element.id).fill(element.color.hex);
        });
        if (this.activeSideCanvas.patchesIsLoaded === false) {
          this.loadPatches();
          this.activeSideCanvas.patchesIsLoaded = true;
        }
        this.jacket.select(`#${this.activeTrimPattern}`).style('display', 'block');
        this.jacket.select(`#${this.activeCollarType.toLowerCase()}`).style('display', 'block');
        this.jacket.select(`#${this.activeJacketType}`).style('display', 'block');
      });
    },

    loadPatches () {
      if (this.patchesBySide(this.jacketSide).ids) {
        this.patchesBySide(this.jacketSide).ids.forEach((patchId) => {
          this.addPatch(patchId, this.patchesBySide(this.jacketSide).data[patchId].options);
        });
      }
    },

    getJacketSvg () {
      return this.jacket.select('#jacket').last();
    },

    onClickOutsideCanvas () {
      this.unselectPatchElements();
    },

    addPatch (patchId, options) {
      const vm = this;
      const patch = this.patchesBySide(this.jacketSide).data[patchId];
      this.activeSideCanvas.canvas.svg(patch.svgText);
      const patchElement = this.activeSideCanvas.canvas.last();

      patchElement.on('delete', () => {
        this.onRemovePatch();
      });

      patchElement.on('edit', function () {
        const svgText = this.svg();
        vm.onEditPatch(svgText, patchId);
      });

      patchElement.on('resizedone', () => {
        this.limitResizePatch(patch, patchElement);
        this.initPatchDraggable(patchElement);
      });

      this.initialTransformPatch(patchElement, options);
      this.initPatchDraggable(patchElement);
      this.unselectPatchElements();
      this.patchElements.push(patchElement);
      this.onSelectPatchElement(patchElement);
    },

    getPatchAvailableSizes (patch) {
      if (patch.isTextPatch) {
        const category = this.patchCategories.data[patch.categoryId];
        return category.sizes
          .filter((sizeData) => sizeData.isChecked)
          .map((sizeData) => sizeData.size);
      }

      const patchModel = this.getPatchModel(patch.originalId);
      return patchModel.availableSlabSize
        .split(', ')
        .filter((size) => !!size)
        .map((size) => parseFloat(size));
    },

    limitResizePatch (patch, patchElement) {
      const INCH_IN_PX = getInchInPx(patch);
      const patchId = patch.id;
      const sizes = this.getPatchAvailableSizes(patch);

      const wrapper = patchElement.select(`#${patchId}--wrapper`).first();
      const scale = wrapper.transform().scaleX;

      const originalWidth = patchElement.width();
      const originalHeight = patchElement.height();
      let biggerSide = originalWidth > originalHeight ? originalWidth : originalHeight;
      if (patch.isTextPatch) {
        biggerSide = originalHeight;
        if (patch.angle !== 0) {
          biggerSide = originalHeight - (originalHeight - patch.textHeight);
        }
      }
      const scaledSidePx = biggerSide * scale;
      const scaledSideInch = scaledSidePx / INCH_IN_PX;
      const closestSize = sizes
        .slice()
        .sort(
          (a, b) => Math.abs(scaledSideInch - a) - Math.abs(scaledSideInch - b)
        )[0];

      const newScale = this.calculateScaleFromSize(patchElement, closestSize, patch);
      wrapper.scale(newScale);
      patchElement.fire('updateSvgSelection');

      const currentSize = this.getPatchSize(patchId);
      if (currentSize.size !== closestSize) {
        const category = this.patchCategories.data[patch.categoryId];
        const sizeObj = category.sizes.find((size) => size.size === closestSize);

        const heightInInch = (originalHeight * newScale) / INCH_IN_PX;
        const widthInInch = (originalWidth * newScale) / INCH_IN_PX;
        this.$store.dispatch('design/setPatchSize', {
          patchId,
          size: {
            ...sizeObj,
            width: widthInInch,
            height: heightInInch
          }
        });
        this.$store.dispatch('finalizeOrder/calculateTotalPrice');
      }
    },

    calculateScaleFromSize (patchElement, size, patch) {
      // eslint-disable-next-line no-nested-ternary
      let sizeCoef = (patch.categoryId === process.env.VUE_APP_PATCH_TEXT_EMBROIDERY) 
        ? 1.25
        : (patch.categoryId === process.env.VUE_APP_PATCH_TEXT_PATCH ? 1 : 1);

      if (patch.categoryId === process.env.VUE_APP_PATCH_TEXT_PATCH 
        && (patch.side === 'left' || patch.side === 'right')) {
        sizeCoef = 1.25;
      }

      if (patch.categoryId === process.env.VUE_APP_PATCH_TEXT_PATCH 
        && ((patch.side).toLowerCase() === 'back')) {
        sizeCoef = 1.25;
      }

      const INCH_IN_PX = getInchInPx(patch);
      const originalWidth = patchElement.width();
      const originalHeight = patchElement.height();

      let biggerSidePx = originalWidth > originalHeight ? originalWidth : originalHeight;
      if (patch.isTextPatch) {
        biggerSidePx = 150;
        if (patch.angle !== 0) {
          biggerSidePx = originalHeight - (originalHeight - patch.textHeight);
        }
      }

      const biggerSideInch = biggerSidePx / INCH_IN_PX;
      return (size * sizeCoef) / biggerSideInch;
    },

    updatePatch (patchId) {
      const patch = this.patchesBySide(this.jacketSide).data[patchId];
      const patchElement = this.activeSideCanvas.canvas.select(`#${patchId}`).first();
      const wrapper = patchElement.select(`#${patchId}--wrapper`).first();
      const transform = wrapper.node.getAttribute('transform');
      const transformData = wrapper.transform();
      const x = patchElement.x();
      const y = patchElement.y();
      const cx = patchElement.cx();
      const cy = patchElement.cy();

      patchElement.selectize(false);
      patchElement.resize('stop');

      this.patchElements = this.patchElements.filter((el) => el.id() !== patchId);
      patchElement.remove();
      this.addPatch(patchId, {
        x,
        y,
        cx,
        cy,
        transform,
        transformData,
        isTextPatch: patch.isTextPatch
      });
      this.unselectPatchElements();
    },

    onEditPatch (svgText, patchId) {
      this.activeSideCanvas.canvas.svg(svgText);
      const tempPatch = this.activeSideCanvas.canvas.last();
      tempPatch.move(0, 0);
      const wrapper = tempPatch.select(`#${patchId}--wrapper`).first();
      wrapper.node.removeAttribute('transform');
      this.patchSvgText = wrapper.svg();
      tempPatch.remove();

      const patch = this.patches.data[patchId];
      this.editingPatchId = patchId;
      this.editingPatchOriginalId = patch.originalId;
      this.isTextEmbroidery = patch.isTextEmbroidery;

      const modalId = this.patchesBySide(this.jacketSide).data[patchId].isTextPatch ? 'exist-text-patch-editor-modal' : 'exist-patch-editor-modal';
      this.$bvModal.show(modalId);
    },

    initialTransformPatch (patchElement, options = null) {
      const patchId = patchElement.id();
      const wrapper = patchElement.select(`#${patchElement.id()}--wrapper`).first();
      const patch = this.patchesBySide(this.jacketSide).data[patchId];
      const INCH_IN_PX = getInchInPx(patch);
      const { isTextPatch } = patch;

      if (options) {
        if (isTextPatch) {
          patchElement.data('isTextPatch', true);
          patchElement.data('font', patch.font);
          patchElement.data('isTextEmbroidery', patch.isTextEmbroidery);
          patchElement.data('side', patch.side);

          if (patch.angle !== 0) {
            const curvePath = patchElement.select('path').first();
            const widthDiff = patchElement.width() - curvePath.width();
            const heightDiff = patchElement.height() - patch.textHeight;
            patchElement.data('xOffset', widthDiff / 2);
            patchElement.data('yOffset', heightDiff);
            patchElement.data('angle', patch.angle);
            patchElement.cx(options.cx);
            patchElement.cy(options.cy);
          } else {
            patchElement.cx(options.cx);
            patchElement.cy(options.cy);
          }
        }
        if (options.x !== undefined) {
          patchElement.x(options.x);
        }

        if (options.y !== undefined) {
          patchElement.y(options.y);
        }

        if (options.transform) {
          wrapper.node.setAttribute('transform', options.transform);
        }

        const currentSize = this.getPatchSize(patchId);
        const newScale = this.calculateScaleFromSize(patchElement, currentSize.size, patch);
        wrapper.scale(newScale);
      } else {
        const jacket = this.getJacketSvg();
        if (patch.isTextPatch) {
          patchElement.data('isTextPatch', true);
          patchElement.data('font', patch.font);
          patchElement.data('isTextEmbroidery', patch.isTextEmbroidery);
        }

        if (patch.isTextPatch && patch.angle !== 0) {
          const curvePath = patchElement.select('path').first();
          const widthDiff = patchElement.width() - curvePath.width();
          const heightDiff = patchElement.height() - patch.textHeight;
          patchElement.data('xOffset', widthDiff / 2);
          patchElement.data('yOffset', heightDiff);
          patchElement.data('angle', patch.angle);
          if (patch.angle > 0) {
            patchElement.cx(jacket.cx() + widthDiff / 2).cy(jacket.cy() + heightDiff);
          } else {
            patchElement.cx(jacket.cx() + widthDiff / 2).cy(jacket.cy());
          }
          patchElement.cx(jacket.cx()).cy(jacket.cy());
        } else {
          patchElement.cx(jacket.cx()).cy(jacket.cy());
        }

        const currentSize = this.getPatchSize(patchId);
        const newScale = this.calculateScaleFromSize(patchElement, currentSize.size, patch);
        wrapper.scale(newScale);

        const heightInInch = (patchElement.height() * newScale) / INCH_IN_PX;
        const widthInInch = (patchElement.width() * newScale) / INCH_IN_PX;
        this.$store.dispatch('design/setPatchSize', {
          patchId,
          size: {
            ...currentSize,
            width: widthInInch,
            height: heightInInch
          }
        });
      }

      return true;
    },

    initPatchDraggable (patchElement) {
      const { canvas } = this.activeSideCanvas;
      const wrapper = patchElement.select(`#${patchElement.id()}--wrapper`).first();
      const jacketImg = this.$refs.imageContainer;
      const scale = wrapper.transform().scaleX;

      const initialWidth = patchElement.width();
      const scaleWidth = initialWidth * scale;
      const widthDiff = (canvas.width() - jacketImg.offsetWidth / 2) - scaleWidth;
      const initialHeight = patchElement.height();
      const scaleHeight = initialHeight * scale;
      const heightDiff = canvas.height() - scaleHeight;

      const constraint = {
        minX: (canvas.cx() - initialWidth / 2) - widthDiff / 2,
        maxX: (canvas.cx() - initialWidth / 2 + scaleWidth) + widthDiff / 2,
        minY: (canvas.cy() - initialHeight / 2) - heightDiff / 2,
        maxY: (canvas.cy() - initialHeight / 2 + scaleHeight) + heightDiff / 2
      };

      patchElement.draggable(false);
      patchElement.draggable(true, constraint);
    },

    unselectPatchElements () {
      this.patchElements.forEach((figure) => {
        figure.selectize(false);
        figure.resize('stop');
      });
      this.activePatchElement = null;
    },

    onSelectPatchElement (patchElement) {
      const vm = this;
      patchElement.mousedown(function (event) {
        event.stopPropagation();
        vm.unselectPatchElements();
        this
          .front()
          .selectize({ scaling: true, hasEditBtn: true })
          .resize({ scaling: true });

        vm.activePatchElement = this;
        vm.selectedPatch = vm.patches.data[patchElement.node.id];
      });
    },

    onRemovePatch () {
      const elementToRemove = this.activePatchElement;
      if (elementToRemove) {
        const patchId = elementToRemove.id();
        this.unselectPatchElements();
        this.patchElements = this.patchElements.filter(
          (element) => element.id() !== patchId
        );
        elementToRemove.remove();
        this.$store.dispatch('design/removePatch', { patchId, side: this.jacketSide });
        this.$store.dispatch('finalizeOrder/calculateTotalPrice');
      }
    }
  }
};
</script>

<style scoped>
.canvas-container {
  width: 815px;
  height: 492px;
  position: relative;
}

.front, .back, .left, .right {
  display: none;
  z-index: 2;
  position: relative;
  width: 815px;
  height: 492px;
}

.activeCanvas {
  display: block;
  width: 815px;
  height: 492px;
}

.total-price-wrap {
  z-index: 10;
  position: absolute;
  right: 0;
  top: 0;
}

.total-price {
  display: flex;
  justify-content: center;
  min-width: 200px;
}
.patch-price-wrap {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}

.patch-sizes-title {
  margin-bottom: 0;
}
.patch-sizes {
  margin-bottom: 0;
}

.jacket-container {
  z-index: 1;
  position: absolute;
  top: 0;
  width: 815px;
  height: 492px;
}

#jacket-wrap{
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.sub-image-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
}

</style>
